/**
 * 1:1 Session booking card (sections/one-on-one.liquid): keeps the running
 * total in step with the hour picker. The form itself is native
 * (quantity = hours → /cart/add → /checkout), so this is enhancement only.
 */
document.querySelectorAll('[data-session-form]').forEach((form) => {
  const out = form.querySelector('[data-session-total-out]');
  if (!out) return;
  form.addEventListener('change', (event) => {
    const input = event.target.closest('[data-session-hours]');
    if (input && input.checked) out.textContent = input.dataset.sessionTotal;
  });
});
